import type {UserEventSpec, UserEventStruct} from '@cohort/shared/schema/apps/userEvent';
import {EmailSchema} from '@cohort/shared/schema/common';
import {z} from 'zod';

export const CohortDigitalAssetTransferredPropertiesSchema = z.object({
  collectionId: z.string().uuid(),
  digitalAssetId: z.string().uuid(),
  ownershipId: z.string().uuid(),
  recipientAddress: EmailSchema.optional(),
});
export type CohortDigitalAssetTransferredProperties = z.infer<
  typeof CohortDigitalAssetTransferredPropertiesSchema
>;

export type CohortDigitalAssetTransferredEventStruct = UserEventStruct<
  'cohort.digital-asset.transferred',
  CohortDigitalAssetTransferredProperties
>;

export const CohortDigitalAssetTransferredEventSpec: UserEventSpec<CohortDigitalAssetTransferredEventStruct> =
  {
    id: 'cohort.digital-asset.transferred',
    propertiesSchema: CohortDigitalAssetTransferredPropertiesSchema,
    rulesEngineConfig: {
      isVisible: true,
      exposedFields: {
        collectionId: {
          resource: 'cohort.digital-asset-collection',
        },
      },
    },
  };
